import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface ApprovalHistoryItem {
  id: string;
  payment_request_id: string;
  approval_level: number;
  status: 'approved' | 'rejected';
  comments: string | null;
  approved_at: string;
  payment_request: {
    id: string;
    request_number: string;
    title: string;
    total_amount: number;
    status: string;
    currency: string | null;
    upload_id: string | null;
    upload_method: string | null;
    requester_first_name: string | null;
    requester_last_name: string | null;
    department: {
      id: string;
      name: string;
    } | null;
  } | null;
}

export const useMyApprovalHistory = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['my-approval-history', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];

      const { data, error } = await supabase
        .from('payment_request_approvals')
        .select(`
          id,
          payment_request_id,
          approval_level,
          status,
          comments,
          approved_at,
          payment_request:payment_requests (
            id,
            request_number,
            title,
            total_amount,
            status,
            currency,
            upload_id,
            upload_method,
            requester_first_name,
            requester_last_name,
            department:departments (
              id,
              name
            )
          )
        `)
        .eq('approver_id', user.id)
        .order('approved_at', { ascending: false });

      if (error) {
        console.error('Error fetching approval history:', error);
        throw error;
      }

      return data as unknown as ApprovalHistoryItem[];
    },
    enabled: !!user?.id,
  });
};